import InitiateTransferAction from "./initiateAssetTransfer/InitiateTransferAction.js";
import RejectTransferAction from "./completeAssetTransfer/RejectTransferAction.js";
import AcceptTransferAction from "./completeAssetTransfer/AcceptTransferAction.js";
export default {
  install: molten => {
    molten.addPlugin('Action', InitiateTransferAction);
    molten.addPlugin('Action', AcceptTransferAction);
    molten.addPlugin('Action', RejectTransferAction);
  }
};